<ul class="nav nav-tabs tab-menu" role="tablist">
  <li *ngFor="let item of model; let i = index" class="nav-item">
    <a class="nav-link" id="{{'tab-menu'+i}}" data-toggle="tab" href="#menu{{i}}" role="tab" aria-selected="false">{{item.title}}</a>
  </li>
</ul>

<div class="tab-content">
  <div *ngFor="let item of model; let i=index" class="tab-pane fade" id="menu{{i}}" role="tabpanel">
    <ng-content select="body"></ng-content>
  </div>